module.exports = __webpack_public_path__ + "img/73.5dbc7ced.png";